import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "Store/configureStore";

export const orderSelector = (state: RootState) => state.organizationOrder;

export const organizationRecurringOrderLoadingSelector = createSelector(
  orderSelector,
  organizationOrder => organizationOrder?.recurring?.loading
);

export const organizationRecurringOrderDataSelector = createSelector(
  orderSelector,
  organizationOrder => organizationOrder?.recurring?.data
);

export const organizationOrdersLoadingSelector = createSelector(
  orderSelector,
  state => state.loading
);

export const unpaidStatusOrders = [
  "past_due",
  "payment_failed_soft_decline",
  "payment_failed_hard_decline",
  "payment_error_disputed",
  "dunning_past_due",
  "cardonfile_payment_error_hard_decline",
  "cardonfile_payment_failed_soft_decline"
];

export const hasUnpaidOrdersDataSelector = (
  state: RootState,
  {
    organizationId,
    userId,
    ownerId
  }: { organizationId: string; userId?: string; ownerId?: string }
) => {
  const dataOrganization = state.organizationOrder?.data?.[organizationId];

  return Object.values(dataOrganization || {})
    ?.flatMap(order => {
      return Object.values(order)?.map(orderData => {
        if (ownerId === userId) return orderData?.status;
      });
    })
    ?.some(value =>
      (unpaidStatusOrders as (string | undefined)[]).includes(value)
    );
};
